export const headers = [
  {
    text: "",
    value: "actions",
    sortable: false,
  },
  {
    text: "Transaction No.",
    value: "transactionNo",
    sortable: false,
  },
  {
    text: "Employee",
    value: "fullName",
    sortable: false,
  },
  {
    text: "Designation",
    value: "desDesc",
    sortable: false,
  },
  {
    text: "Department",
    value: "depDesc",
    sortable: false,
  },
  {
    text: "Section",
    value: "secDesc",
    sortable: false,
  },
  {
    text: "Movement Type",
    value: "movementTypeDesc",
    sortable: false,
  },
];
